import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/live-demo/basic',
    component: ComponentCreator('/live-demo/basic', '938'),
    exact: true
  },
  {
    path: '/live-demo/rdf',
    component: ComponentCreator('/live-demo/rdf', '20e'),
    exact: true
  },
  {
    path: '/live-demo/stress-test',
    component: ComponentCreator('/live-demo/stress-test', '156'),
    exact: true
  },
  {
    path: '/live-demo/wikidata',
    component: ComponentCreator('/live-demo/wikidata', '732'),
    exact: true
  },
  {
    path: '/markdown-page',
    component: ComponentCreator('/markdown-page', '3d7'),
    exact: true
  },
  {
    path: '/playground/basic',
    component: ComponentCreator('/playground/basic', '283'),
    exact: true
  },
  {
    path: '/playground/classic-workspace',
    component: ComponentCreator('/playground/classic-workspace', 'bda'),
    exact: true
  },
  {
    path: '/playground/graph-authoring',
    component: ComponentCreator('/playground/graph-authoring', '9ca'),
    exact: true
  },
  {
    path: '/playground/rdf-explorer',
    component: ComponentCreator('/playground/rdf-explorer', '9f3'),
    exact: true
  },
  {
    path: '/playground/sparql',
    component: ComponentCreator('/playground/sparql', '697'),
    exact: true
  },
  {
    path: '/playground/stress-test',
    component: ComponentCreator('/playground/stress-test', '0e7'),
    exact: true
  },
  {
    path: '/playground/style-customization',
    component: ComponentCreator('/playground/style-customization', '448'),
    exact: true
  },
  {
    path: '/playground/wikidata',
    component: ComponentCreator('/playground/wikidata', 'e64'),
    exact: true
  },
  {
    path: '/search',
    component: ComponentCreator('/search', '822'),
    exact: true
  },
  {
    path: '/tools/genealogical-tree-editor',
    component: ComponentCreator('/tools/genealogical-tree-editor', 'edc'),
    exact: true
  },
  {
    path: '/docs',
    component: ComponentCreator('/docs', '95f'),
    routes: [
      {
        path: '/docs',
        component: ComponentCreator('/docs', '9ab'),
        routes: [
          {
            path: '/docs',
            component: ComponentCreator('/docs', 'd9f'),
            routes: [
              {
                path: '/docs/',
                component: ComponentCreator('/docs/', 'be8'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/api/',
                component: ComponentCreator('/docs/api/', 'e35'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/forms/',
                component: ComponentCreator('/docs/api/forms/', '014'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/forms/classes/MemoryFileUploader',
                component: ComponentCreator('/docs/api/forms/classes/MemoryFileUploader', '8c9'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/forms/functions/InlineDiagnostic',
                component: ComponentCreator('/docs/api/forms/functions/InlineDiagnostic', 'd92'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/forms/functions/InputFile',
                component: ComponentCreator('/docs/api/forms/functions/InputFile', '0a8'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/forms/functions/InputList',
                component: ComponentCreator('/docs/api/forms/functions/InputList', 'eef'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/forms/functions/InputSelect',
                component: ComponentCreator('/docs/api/forms/functions/InputSelect', '36d'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/forms/functions/InputText',
                component: ComponentCreator('/docs/api/forms/functions/InputText', 'd24'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/forms/interfaces/FileUploadProvider',
                component: ComponentCreator('/docs/api/forms/interfaces/FileUploadProvider', 'c63'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/forms/interfaces/InputFileProps',
                component: ComponentCreator('/docs/api/forms/interfaces/InputFileProps', 'c37'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/forms/interfaces/InputListProps',
                component: ComponentCreator('/docs/api/forms/interfaces/InputListProps', '675'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/forms/interfaces/InputMultiProps',
                component: ComponentCreator('/docs/api/forms/interfaces/InputMultiProps', '3c6'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/forms/interfaces/InputSelectProps',
                component: ComponentCreator('/docs/api/forms/interfaces/InputSelectProps', '879'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/forms/interfaces/InputSelectVariant',
                component: ComponentCreator('/docs/api/forms/interfaces/InputSelectVariant', '088'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/forms/interfaces/InputSingleProps',
                component: ComponentCreator('/docs/api/forms/interfaces/InputSingleProps', '9de'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/forms/interfaces/InputTextProps',
                component: ComponentCreator('/docs/api/forms/interfaces/InputTextProps', 'b77'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/forms/interfaces/MemoryUploadedFile',
                component: ComponentCreator('/docs/api/forms/interfaces/MemoryUploadedFile', '460'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/forms/interfaces/UploadedFile',
                component: ComponentCreator('/docs/api/forms/interfaces/UploadedFile', '714'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/forms/type-aliases/InputFileCategory',
                component: ComponentCreator('/docs/api/forms/type-aliases/InputFileCategory', 'ca0'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/forms/type-aliases/InputMultiResolver',
                component: ComponentCreator('/docs/api/forms/type-aliases/InputMultiResolver', '0d5'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/forms/type-aliases/InputMultiUpdater',
                component: ComponentCreator('/docs/api/forms/type-aliases/InputMultiUpdater', '257'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/forms/variables/FileType',
                component: ComponentCreator('/docs/api/forms/variables/FileType', '205'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/layout-sync/',
                component: ComponentCreator('/docs/api/layout-sync/', 'f68'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/layout-sync/functions/blockingDefaultLayout',
                component: ComponentCreator('/docs/api/layout-sync/functions/blockingDefaultLayout', '3f8'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/layout-sync/functions/colaFlowLayout',
                component: ComponentCreator('/docs/api/layout-sync/functions/colaFlowLayout', 'b99'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/layout-sync/functions/colaForceLayout',
                component: ComponentCreator('/docs/api/layout-sync/functions/colaForceLayout', '396'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/layout-sync/functions/colaRemoveOverlaps',
                component: ComponentCreator('/docs/api/layout-sync/functions/colaRemoveOverlaps', '8b3'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/layout-sync/functions/evaluateColaLayout',
                component: ComponentCreator('/docs/api/layout-sync/functions/evaluateColaLayout', '5b9'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/layout-sync/functions/getContentFittingBoxForLayout',
                component: ComponentCreator('/docs/api/layout-sync/functions/getContentFittingBoxForLayout', '085'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/layout-sync/functions/layoutPadded',
                component: ComponentCreator('/docs/api/layout-sync/functions/layoutPadded', '0aa'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/layout-sync/functions/layoutPaddedBiasFree',
                component: ComponentCreator('/docs/api/layout-sync/functions/layoutPaddedBiasFree', '85f'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/layout-sync/interfaces/ColaFlowLayoutOptions',
                component: ComponentCreator('/docs/api/layout-sync/interfaces/ColaFlowLayoutOptions', 'ae6'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/layout-sync/interfaces/ColaForceLayoutOptions',
                component: ComponentCreator('/docs/api/layout-sync/interfaces/ColaForceLayoutOptions', '884'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/layout-sync/interfaces/DefaultLayoutOptions',
                component: ComponentCreator('/docs/api/layout-sync/interfaces/DefaultLayoutOptions', '6b9'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/layout-sync/interfaces/PaddedBiasFreeLayoutState',
                component: ComponentCreator('/docs/api/layout-sync/interfaces/PaddedBiasFreeLayoutState', '7d2'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/layout-sync/interfaces/PaddedLayoutState',
                component: ComponentCreator('/docs/api/layout-sync/interfaces/PaddedLayoutState', '26c'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/layout.worker/',
                component: ComponentCreator('/docs/api/layout.worker/', '65a'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/layout.worker/classes/DefaultLayouts',
                component: ComponentCreator('/docs/api/layout.worker/classes/DefaultLayouts', '4c9'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/legacy-styles/',
                component: ComponentCreator('/docs/api/legacy-styles/', '447'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/legacy-styles/functions/makeLinkStyleShowIri',
                component: ComponentCreator('/docs/api/legacy-styles/functions/makeLinkStyleShowIri', 'da5'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/legacy-styles/functions/makeOntologyLinkTemplates',
                component: ComponentCreator('/docs/api/legacy-styles/functions/makeOntologyLinkTemplates', '172'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/legacy-styles/variables/SemanticTypeStyles',
                component: ComponentCreator('/docs/api/legacy-styles/variables/SemanticTypeStyles', '087'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/',
                component: ComponentCreator('/docs/api/workspace/', '9d3'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/AnnotationElement',
                component: ComponentCreator('/docs/api/workspace/classes/AnnotationElement', 'bc8'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/AnnotationLink',
                component: ComponentCreator('/docs/api/workspace/classes/AnnotationLink', 'd17'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/BaseMetadataProvider',
                component: ComponentCreator('/docs/api/workspace/classes/BaseMetadataProvider', 'b0c'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/CommandBusTopic',
                component: ComponentCreator('/docs/api/workspace/classes/CommandBusTopic', '726'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/CompositeDataProvider',
                component: ComponentCreator('/docs/api/workspace/classes/CompositeDataProvider', 'b69'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/DataDiagramModel',
                component: ComponentCreator('/docs/api/workspace/classes/DataDiagramModel', '8e7'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/Debouncer',
                component: ComponentCreator('/docs/api/workspace/classes/Debouncer', 'b6a'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/DecoratedDataProvider',
                component: ComponentCreator('/docs/api/workspace/classes/DecoratedDataProvider', 'b2d'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/DefaultDataLocaleProvider',
                component: ComponentCreator('/docs/api/workspace/classes/DefaultDataLocaleProvider', 'c13'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/DefaultDialogSettingsProvider',
                component: ComponentCreator('/docs/api/workspace/classes/DefaultDialogSettingsProvider', '94d'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/DefaultLinkRouter',
                component: ComponentCreator('/docs/api/workspace/classes/DefaultLinkRouter', '596'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/DefaultRenameLinkProvider',
                component: ComponentCreator('/docs/api/workspace/classes/DefaultRenameLinkProvider', '509'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/DefaultTranslation',
                component: ComponentCreator('/docs/api/workspace/classes/DefaultTranslation', 'e5d'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/DiagramModel',
                component: ComponentCreator('/docs/api/workspace/classes/DiagramModel', '2ab'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/EditorController',
                component: ComponentCreator('/docs/api/workspace/classes/EditorController', '12c'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/Element',
                component: ComponentCreator('/docs/api/workspace/classes/Element', '131'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/ElementType',
                component: ComponentCreator('/docs/api/workspace/classes/ElementType', '095'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/EmptyDataProvider',
                component: ComponentCreator('/docs/api/workspace/classes/EmptyDataProvider', '084'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/EntityElement',
                component: ComponentCreator('/docs/api/workspace/classes/EntityElement', '6dc'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/EntityGroup',
                component: ComponentCreator('/docs/api/workspace/classes/EntityGroup', 'a36'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/EventObserver',
                component: ComponentCreator('/docs/api/workspace/classes/EventObserver', 'd5d'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/EventSource',
                component: ComponentCreator('/docs/api/workspace/classes/EventSource', 'b5c'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/IndexedDbCachedProvider',
                component: ComponentCreator('/docs/api/workspace/classes/IndexedDbCachedProvider', '440'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/InMemoryHistory',
                component: ComponentCreator('/docs/api/workspace/classes/InMemoryHistory', '8d1'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/KeyedObserver',
                component: ComponentCreator('/docs/api/workspace/classes/KeyedObserver', '4f2'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/Link',
                component: ComponentCreator('/docs/api/workspace/classes/Link', '1c6'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/LinkType',
                component: ComponentCreator('/docs/api/workspace/classes/LinkType', '21d'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/LinkVertex',
                component: ComponentCreator('/docs/api/workspace/classes/LinkVertex', '585'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/OverlayController',
                component: ComponentCreator('/docs/api/workspace/classes/OverlayController', '031'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/PropertyType',
                component: ComponentCreator('/docs/api/workspace/classes/PropertyType', 'be7'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/RdfDataProvider',
                component: ComponentCreator('/docs/api/workspace/classes/RdfDataProvider', '20b'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/RelationGroup',
                component: ComponentCreator('/docs/api/workspace/classes/RelationGroup', 'e49'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/RelationLink',
                component: ComponentCreator('/docs/api/workspace/classes/RelationLink', '460'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/RenameLinkToLinkStateProvider',
                component: ComponentCreator('/docs/api/workspace/classes/RenameLinkToLinkStateProvider', '4e3'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/RestoreGeometry',
                component: ComponentCreator('/docs/api/workspace/classes/RestoreGeometry', 'a31'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/SharedCanvasState',
                component: ComponentCreator('/docs/api/workspace/classes/SharedCanvasState', '431'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/SparqlDataProvider',
                component: ComponentCreator('/docs/api/workspace/classes/SparqlDataProvider', '206'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/TemplateState',
                component: ComponentCreator('/docs/api/workspace/classes/TemplateState', '6ca'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/TranslatedText',
                component: ComponentCreator('/docs/api/workspace/classes/TranslatedText', 'f07'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/VoidElement',
                component: ComponentCreator('/docs/api/workspace/classes/VoidElement', '4c3'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/classes/Workspace',
                component: ComponentCreator('/docs/api/workspace/classes/Workspace', '2e4'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/enumerations/IndexQuadBy',
                component: ComponentCreator('/docs/api/workspace/enumerations/IndexQuadBy', '448'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/enumerations/RenderingLayer',
                component: ComponentCreator('/docs/api/workspace/enumerations/RenderingLayer', '72b'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/enumerations/WorkspaceEventKey',
                component: ComponentCreator('/docs/api/workspace/enumerations/WorkspaceEventKey', '143'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/animateInterval',
                component: ComponentCreator('/docs/api/workspace/functions/animateInterval', '425'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/AnnotationSupport',
                component: ComponentCreator('/docs/api/workspace/functions/AnnotationSupport', 'b85'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/applyLayout',
                component: ComponentCreator('/docs/api/workspace/functions/applyLayout', '3c2'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/BasicLink',
                component: ComponentCreator('/docs/api/workspace/functions/BasicLink', 'e50'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/boundsOf',
                component: ComponentCreator('/docs/api/workspace/functions/boundsOf', '79c'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/calculateAveragePosition',
                component: ComponentCreator('/docs/api/workspace/functions/calculateAveragePosition', '0ed'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/calculateLayout',
                component: ComponentCreator('/docs/api/workspace/functions/calculateLayout', 'ecd'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/Canvas',
                component: ComponentCreator('/docs/api/workspace/functions/Canvas', '0b1'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/CanvasPlaceAt',
                component: ComponentCreator('/docs/api/workspace/functions/CanvasPlaceAt', '3eb'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/changeEntityData',
                component: ComponentCreator('/docs/api/workspace/functions/changeEntityData', '05f'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/changeLinkTypeVisibility',
                component: ComponentCreator('/docs/api/workspace/functions/changeLinkTypeVisibility', '6ab'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/changeRelationData',
                component: ComponentCreator('/docs/api/workspace/functions/changeRelationData', '601'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/ClassicEntity',
                component: ComponentCreator('/docs/api/workspace/functions/ClassicEntity', '47c'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/ClassicToolbar',
                component: ComponentCreator('/docs/api/workspace/functions/ClassicToolbar', '23a'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/ClassicWorkspace',
                component: ComponentCreator('/docs/api/workspace/functions/ClassicWorkspace', '176'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/ClassTree',
                component: ComponentCreator('/docs/api/workspace/functions/ClassTree', '573'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/computePolyline',
                component: ComponentCreator('/docs/api/workspace/functions/computePolyline', 'c36'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/computePolylineLength',
                component: ComponentCreator('/docs/api/workspace/functions/computePolylineLength', '97e'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/ConnectionsMenu',
                component: ComponentCreator('/docs/api/workspace/functions/ConnectionsMenu', '973'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/createWorkspace',
                component: ComponentCreator('/docs/api/workspace/functions/createWorkspace', '8dd'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/defaultGetDroppedOnCanvasItems',
                component: ComponentCreator('/docs/api/workspace/functions/defaultGetDroppedOnCanvasItems', '3b9'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/DefaultLink',
                component: ComponentCreator('/docs/api/workspace/functions/DefaultLink', '923'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/DefaultPropertyEditor',
                component: ComponentCreator('/docs/api/workspace/functions/DefaultPropertyEditor', '4f9'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/DefaultWorkspace',
                component: ComponentCreator('/docs/api/workspace/functions/DefaultWorkspace', '263'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/defineLayoutWorker',
                component: ComponentCreator('/docs/api/workspace/functions/defineLayoutWorker', '1c6'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/delay',
                component: ComponentCreator('/docs/api/workspace/functions/delay', 'ccd'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/delayProviderDecorator',
                component: ComponentCreator('/docs/api/workspace/functions/delayProviderDecorator', 'e49'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/DraggableHandle',
                component: ComponentCreator('/docs/api/workspace/functions/DraggableHandle', '205'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/DropdownMenu',
                component: ComponentCreator('/docs/api/workspace/functions/DropdownMenu', 'de6'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/DropdownMenuItem',
                component: ComponentCreator('/docs/api/workspace/functions/DropdownMenuItem', '91e'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/DropOnCanvas',
                component: ComponentCreator('/docs/api/workspace/functions/DropOnCanvas', 'c06'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/ElementDecoration',
                component: ComponentCreator('/docs/api/workspace/functions/ElementDecoration', 'a53'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/EntityEditor',
                component: ComponentCreator('/docs/api/workspace/functions/EntityEditor', 'a7f'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/equalElements',
                component: ComponentCreator('/docs/api/workspace/functions/equalElements', '501'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/equalLinks',
                component: ComponentCreator('/docs/api/workspace/functions/equalLinks', 'bfb'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/equalProperties',
                component: ComponentCreator('/docs/api/workspace/functions/equalProperties', '7ca'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/equalSubtypeEdges',
                component: ComponentCreator('/docs/api/workspace/functions/equalSubtypeEdges', '394'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/findElementAtPoint',
                component: ComponentCreator('/docs/api/workspace/functions/findElementAtPoint', 'cec'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/findNearestSegmentIndex',
                component: ComponentCreator('/docs/api/workspace/functions/findNearestSegmentIndex', '7be'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/FocusGroup',
                component: ComponentCreator('/docs/api/workspace/functions/FocusGroup', '1c1'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/getContentFittingBox',
                component: ComponentCreator('/docs/api/workspace/functions/getContentFittingBox', '3b4'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/getPointAlongPolyline',
                component: ComponentCreator('/docs/api/workspace/functions/getPointAlongPolyline', 'd85'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/groupEntities',
                component: ComponentCreator('/docs/api/workspace/functions/groupEntities', 'c59'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/GroupPaginator',
                component: ComponentCreator('/docs/api/workspace/functions/GroupPaginator', '5ba'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/Halo',
                component: ComponentCreator('/docs/api/workspace/functions/Halo', 'b62'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/HaloLink',
                component: ComponentCreator('/docs/api/workspace/functions/HaloLink', 'ba5'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/hashLink',
                component: ComponentCreator('/docs/api/workspace/functions/hashLink', '535'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/hashSubtypeEdge',
                component: ComponentCreator('/docs/api/workspace/functions/hashSubtypeEdge', '334'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/highlightSubstring',
                component: ComponentCreator('/docs/api/workspace/functions/highlightSubstring', 'e3e'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/HtmlSpinner',
                component: ComponentCreator('/docs/api/workspace/functions/HtmlSpinner', '825'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/indexedDataset',
                component: ComponentCreator('/docs/api/workspace/functions/indexedDataset', 'd31'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/InstancesSearch',
                component: ComponentCreator('/docs/api/workspace/functions/InstancesSearch', 'aaa'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/isEncodedBlank',
                component: ComponentCreator('/docs/api/workspace/functions/isEncodedBlank', '213'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/isPolylineEqual',
                component: ComponentCreator('/docs/api/workspace/functions/isPolylineEqual', 'cfd'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/iterateEntitiesOf',
                component: ComponentCreator('/docs/api/workspace/functions/iterateEntitiesOf', '1d6'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/iterateRelationsOf',
                component: ComponentCreator('/docs/api/workspace/functions/iterateRelationsOf', 'a9c'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/LinkAction',
                component: ComponentCreator('/docs/api/workspace/functions/LinkAction', 'e3a'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/LinkActionDelete',
                component: ComponentCreator('/docs/api/workspace/functions/LinkActionDelete', 'c13'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/LinkActionEdit',
                component: ComponentCreator('/docs/api/workspace/functions/LinkActionEdit', '363'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/LinkActionMoveEndpoint',
                component: ComponentCreator('/docs/api/workspace/functions/LinkActionMoveEndpoint', 'eea'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/LinkActionRename',
                component: ComponentCreator('/docs/api/workspace/functions/LinkActionRename', '871'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/LinkActionSpinner',
                component: ComponentCreator('/docs/api/workspace/functions/LinkActionSpinner', 'b8a'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/LinkLabel',
                component: ComponentCreator('/docs/api/workspace/functions/LinkLabel', '14b'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/LinkPath',
                component: ComponentCreator('/docs/api/workspace/functions/LinkPath', 'd13'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/LinkTypesToolbox',
                component: ComponentCreator('/docs/api/workspace/functions/LinkTypesToolbox', '308'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/LinkVertices',
                component: ComponentCreator('/docs/api/workspace/functions/LinkVertices', '2c1'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/ListElementView',
                component: ComponentCreator('/docs/api/workspace/functions/ListElementView', 'e21'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/mapAbortedToNull',
                component: ComponentCreator('/docs/api/workspace/functions/mapAbortedToNull', '9a9'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/moveComparator',
                component: ComponentCreator('/docs/api/workspace/functions/moveComparator', '608'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/Navigator',
                component: ComponentCreator('/docs/api/workspace/functions/Navigator', 'fe2'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/NoteAnnotation',
                component: ComponentCreator('/docs/api/workspace/functions/NoteAnnotation', '95d'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/NoteEntity',
                component: ComponentCreator('/docs/api/workspace/functions/NoteEntity', '353'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/NoteLink',
                component: ComponentCreator('/docs/api/workspace/functions/NoteLink', 'abf'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/paneTopLeft',
                component: ComponentCreator('/docs/api/workspace/functions/paneTopLeft', '173'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/pathFromPolyline',
                component: ComponentCreator('/docs/api/workspace/functions/pathFromPolyline', '76b'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/placeElementsAroundTarget',
                component: ComponentCreator('/docs/api/workspace/functions/placeElementsAroundTarget', '4a0'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/ProgressBar',
                component: ComponentCreator('/docs/api/workspace/functions/ProgressBar', 'd0e'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/RelationEditor',
                component: ComponentCreator('/docs/api/workspace/functions/RelationEditor', '9b4'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/RelationTypeSelector',
                component: ComponentCreator('/docs/api/workspace/functions/RelationTypeSelector', '128'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/requestElementData',
                component: ComponentCreator('/docs/api/workspace/functions/requestElementData', 'f67'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/restoreCapturedLinkGeometry',
                component: ComponentCreator('/docs/api/workspace/functions/restoreCapturedLinkGeometry', '910'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/restoreLinksBetweenElements',
                component: ComponentCreator('/docs/api/workspace/functions/restoreLinksBetweenElements', 'd98'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/restoreViewport',
                component: ComponentCreator('/docs/api/workspace/functions/restoreViewport', 'ca0'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/RoundEntity',
                component: ComponentCreator('/docs/api/workspace/functions/RoundEntity', '2c6'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/SearchResults',
                component: ComponentCreator('/docs/api/workspace/functions/SearchResults', 'd7b'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/SearchSectionElementTypes',
                component: ComponentCreator('/docs/api/workspace/functions/SearchSectionElementTypes', '9de'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/SearchSectionEntities',
                component: ComponentCreator('/docs/api/workspace/functions/SearchSectionEntities', 'e2d'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/SearchSectionLinkTypes',
                component: ComponentCreator('/docs/api/workspace/functions/SearchSectionLinkTypes', '574'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/Selection',
                component: ComponentCreator('/docs/api/workspace/functions/Selection', '56e'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/SelectionAction',
                component: ComponentCreator('/docs/api/workspace/functions/SelectionAction', '5bd'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/SelectionActionAddToFilter',
                component: ComponentCreator('/docs/api/workspace/functions/SelectionActionAddToFilter', 'adb'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/SelectionActionAnchor',
                component: ComponentCreator('/docs/api/workspace/functions/SelectionActionAnchor', '368'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/SelectionActionAnnotate',
                component: ComponentCreator('/docs/api/workspace/functions/SelectionActionAnnotate', 'd2e'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/SelectionActionConnections',
                component: ComponentCreator('/docs/api/workspace/functions/SelectionActionConnections', '8f4'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/SelectionActionEstablishLink',
                component: ComponentCreator('/docs/api/workspace/functions/SelectionActionEstablishLink', '157'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/SelectionActionExpand',
                component: ComponentCreator('/docs/api/workspace/functions/SelectionActionExpand', '586'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/SelectionActionGroup',
                component: ComponentCreator('/docs/api/workspace/functions/SelectionActionGroup', '1bc'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/SelectionActionLayout',
                component: ComponentCreator('/docs/api/workspace/functions/SelectionActionLayout', '8b0'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/SelectionActionRemove',
                component: ComponentCreator('/docs/api/workspace/functions/SelectionActionRemove', '7e9'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/SelectionActionSpinner',
                component: ComponentCreator('/docs/api/workspace/functions/SelectionActionSpinner', '4c1'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/SelectionActionZoomToFit',
                component: ComponentCreator('/docs/api/workspace/functions/SelectionActionZoomToFit', '524'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/setElementExpanded',
                component: ComponentCreator('/docs/api/workspace/functions/setElementExpanded', 'b1e'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/setElementState',
                component: ComponentCreator('/docs/api/workspace/functions/setElementState', 'cf9'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/setEntityElementData',
                component: ComponentCreator('/docs/api/workspace/functions/setEntityElementData', 'db3'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/setEntityGroupItems',
                component: ComponentCreator('/docs/api/workspace/functions/setEntityGroupItems', '38b'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/setLinkState',
                component: ComponentCreator('/docs/api/workspace/functions/setLinkState', 'cc0'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/setRelationGroupItems',
                component: ComponentCreator('/docs/api/workspace/functions/setRelationGroupItems', 'b78'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/setRelationLinkData',
                component: ComponentCreator('/docs/api/workspace/functions/setRelationLinkData', '879'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/shallowArrayEqual',
                component: ComponentCreator('/docs/api/workspace/functions/shallowArrayEqual', '160'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/Spinner',
                component: ComponentCreator('/docs/api/workspace/functions/Spinner', 'e36'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/StandardEntity',
                component: ComponentCreator('/docs/api/workspace/functions/StandardEntity', '131'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/StandardEntityGroup',
                component: ComponentCreator('/docs/api/workspace/functions/StandardEntityGroup', '2d4'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/StandardRelation',
                component: ComponentCreator('/docs/api/workspace/functions/StandardRelation', '9af'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/startDragElements',
                component: ComponentCreator('/docs/api/workspace/functions/startDragElements', 'b2b'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/Toolbar',
                component: ComponentCreator('/docs/api/workspace/functions/Toolbar', '6fd'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/ToolbarAction',
                component: ComponentCreator('/docs/api/workspace/functions/ToolbarAction', 'b50'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/ToolbarActionClearAll',
                component: ComponentCreator('/docs/api/workspace/functions/ToolbarActionClearAll', '1aa'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/ToolbarActionExport',
                component: ComponentCreator('/docs/api/workspace/functions/ToolbarActionExport', 'd50'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/ToolbarActionLayout',
                component: ComponentCreator('/docs/api/workspace/functions/ToolbarActionLayout', '33c'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/ToolbarActionOpen',
                component: ComponentCreator('/docs/api/workspace/functions/ToolbarActionOpen', '064'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/ToolbarActionRedo',
                component: ComponentCreator('/docs/api/workspace/functions/ToolbarActionRedo', '52d'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/ToolbarActionSave',
                component: ComponentCreator('/docs/api/workspace/functions/ToolbarActionSave', '24f'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/ToolbarActionUndo',
                component: ComponentCreator('/docs/api/workspace/functions/ToolbarActionUndo', '939'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/ToolbarLanguageSelector',
                component: ComponentCreator('/docs/api/workspace/functions/ToolbarLanguageSelector', '172'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/totalPaneSize',
                component: ComponentCreator('/docs/api/workspace/functions/totalPaneSize', '10b'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/translateToPositiveQuadrant',
                component: ComponentCreator('/docs/api/workspace/functions/translateToPositiveQuadrant', '74e'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/TranslationProvider',
                component: ComponentCreator('/docs/api/workspace/functions/TranslationProvider', '12a'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/ungroupAllEntities',
                component: ComponentCreator('/docs/api/workspace/functions/ungroupAllEntities', '04c'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/ungroupSomeEntities',
                component: ComponentCreator('/docs/api/workspace/functions/ungroupSomeEntities', 'd1b'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/UnifiedSearch',
                component: ComponentCreator('/docs/api/workspace/functions/UnifiedSearch', '7e2'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/uniformGrid',
                component: ComponentCreator('/docs/api/workspace/functions/uniformGrid', '315'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/useAsync',
                component: ComponentCreator('/docs/api/workspace/functions/useAsync', '319'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/useAuthoredEntity',
                component: ComponentCreator('/docs/api/workspace/functions/useAuthoredEntity', '7a6'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/useCanvas',
                component: ComponentCreator('/docs/api/workspace/functions/useCanvas', '2be'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/useCanvasHotkey',
                component: ComponentCreator('/docs/api/workspace/functions/useCanvasHotkey', '878'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/useColorScheme',
                component: ComponentCreator('/docs/api/workspace/functions/useColorScheme', 'fa8'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/useEventStore',
                component: ComponentCreator('/docs/api/workspace/functions/useEventStore', '0e0'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/useFocusGroup',
                component: ComponentCreator('/docs/api/workspace/functions/useFocusGroup', 'f51'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/useFocusGroupItem',
                component: ComponentCreator('/docs/api/workspace/functions/useFocusGroupItem', 'd2d'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/useFrameDebouncedStore',
                component: ComponentCreator('/docs/api/workspace/functions/useFrameDebouncedStore', 'e1d'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/useKeyedSyncStore',
                component: ComponentCreator('/docs/api/workspace/functions/useKeyedSyncStore', '7ce'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/useLayerDebouncedStore',
                component: ComponentCreator('/docs/api/workspace/functions/useLayerDebouncedStore', '885'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/useLinkActionContext',
                component: ComponentCreator('/docs/api/workspace/functions/useLinkActionContext', 'd9b'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/useLoadedWorkspace',
                component: ComponentCreator('/docs/api/workspace/functions/useLoadedWorkspace', '40e'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/useObservedProperty',
                component: ComponentCreator('/docs/api/workspace/functions/useObservedProperty', 'f69'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/useProvidedEntities',
                component: ComponentCreator('/docs/api/workspace/functions/useProvidedEntities', 'd0d'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/useResolvedAssetUrl',
                component: ComponentCreator('/docs/api/workspace/functions/useResolvedAssetUrl', 'c2b'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/useSearchInputStore',
                component: ComponentCreator('/docs/api/workspace/functions/useSearchInputStore', '9ed'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/useSyncStore',
                component: ComponentCreator('/docs/api/workspace/functions/useSyncStore', '89b'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/useSyncStoreWithComparator',
                component: ComponentCreator('/docs/api/workspace/functions/useSyncStoreWithComparator', 'dbd'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/useTranslation',
                component: ComponentCreator('/docs/api/workspace/functions/useTranslation', 'bf2'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/useUnifiedSearchSection',
                component: ComponentCreator('/docs/api/workspace/functions/useUnifiedSearchSection', 'ede'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/useWorker',
                component: ComponentCreator('/docs/api/workspace/functions/useWorker', '067'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/useWorkspace',
                component: ComponentCreator('/docs/api/workspace/functions/useWorkspace', '7d9'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/ViewportDock',
                component: ComponentCreator('/docs/api/workspace/functions/ViewportDock', '365'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/VisualAuthoring',
                component: ComponentCreator('/docs/api/workspace/functions/VisualAuthoring', '643'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/WithFetchStatus',
                component: ComponentCreator('/docs/api/workspace/functions/WithFetchStatus', 'e31'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/WorkspaceLayoutColumn',
                component: ComponentCreator('/docs/api/workspace/functions/WorkspaceLayoutColumn', '677'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/WorkspaceLayoutItem',
                component: ComponentCreator('/docs/api/workspace/functions/WorkspaceLayoutItem', '75f'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/WorkspaceLayoutRow',
                component: ComponentCreator('/docs/api/workspace/functions/WorkspaceLayoutRow', 'c0b'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/WorkspaceProvider',
                component: ComponentCreator('/docs/api/workspace/functions/WorkspaceProvider', 'bae'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/WorkspaceRoot',
                component: ComponentCreator('/docs/api/workspace/functions/WorkspaceRoot', 'dbe'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/functions/ZoomControl',
                component: ComponentCreator('/docs/api/workspace/functions/ZoomControl', 'edd'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/AnnotationCommands',
                component: ComponentCreator('/docs/api/workspace/interfaces/AnnotationCommands', '1df'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/AnnotationContent',
                component: ComponentCreator('/docs/api/workspace/interfaces/AnnotationContent', '0b2'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/AnnotationSupportProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/AnnotationSupportProps', '4ea'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/AnyEvent',
                component: ComponentCreator('/docs/api/workspace/interfaces/AnyEvent', '180'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/AuthoredEntityAdd',
                component: ComponentCreator('/docs/api/workspace/interfaces/AuthoredEntityAdd', 'd5b'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/AuthoredEntityChange',
                component: ComponentCreator('/docs/api/workspace/interfaces/AuthoredEntityChange', '735'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/AuthoredEntityContext',
                component: ComponentCreator('/docs/api/workspace/interfaces/AuthoredEntityContext', '5dc'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/AuthoredEntityDelete',
                component: ComponentCreator('/docs/api/workspace/interfaces/AuthoredEntityDelete', '318'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/AuthoredRelationAdd',
                component: ComponentCreator('/docs/api/workspace/interfaces/AuthoredRelationAdd', 'cb4'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/AuthoredRelationChange',
                component: ComponentCreator('/docs/api/workspace/interfaces/AuthoredRelationChange', 'b78'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/AuthoredRelationDelete',
                component: ComponentCreator('/docs/api/workspace/interfaces/AuthoredRelationDelete', '4f7'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/AuthoringState',
                component: ComponentCreator('/docs/api/workspace/interfaces/AuthoringState', '74d'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/BasicLinkProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/BasicLinkProps', '992'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/CalculatedLayout',
                component: ComponentCreator('/docs/api/workspace/interfaces/CalculatedLayout', 'e9c'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/CanvasApi',
                component: ComponentCreator('/docs/api/workspace/interfaces/CanvasApi', '903'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/CanvasContextMenuEvent',
                component: ComponentCreator('/docs/api/workspace/interfaces/CanvasContextMenuEvent', '57b'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/CanvasDragoverEvent',
                component: ComponentCreator('/docs/api/workspace/interfaces/CanvasDragoverEvent', '9d7'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/CanvasDropEvent',
                component: ComponentCreator('/docs/api/workspace/interfaces/CanvasDropEvent', 'a9d'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/CanvasEvents',
                component: ComponentCreator('/docs/api/workspace/interfaces/CanvasEvents', '196'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/CanvasHotkey',
                component: ComponentCreator('/docs/api/workspace/interfaces/CanvasHotkey', '602'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/CanvasKeyboardEvent',
                component: ComponentCreator('/docs/api/workspace/interfaces/CanvasKeyboardEvent', '30a'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/CanvasMetrics',
                component: ComponentCreator('/docs/api/workspace/interfaces/CanvasMetrics', 'ca7'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/CanvasPaneMetrics',
                component: ComponentCreator('/docs/api/workspace/interfaces/CanvasPaneMetrics', 'dda'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/CanvasPointerEvent',
                component: ComponentCreator('/docs/api/workspace/interfaces/CanvasPointerEvent', 'bee'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/CanvasPointerUpEvent',
                component: ComponentCreator('/docs/api/workspace/interfaces/CanvasPointerUpEvent', '2db'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/CanvasProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/CanvasProps', 'aed'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/CanvasResizeEvent',
                component: ComponentCreator('/docs/api/workspace/interfaces/CanvasResizeEvent', '6f1'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/CanvasScrollEvent',
                component: ComponentCreator('/docs/api/workspace/interfaces/CanvasScrollEvent', '3e3'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/CellsChangedEvent',
                component: ComponentCreator('/docs/api/workspace/interfaces/CellsChangedEvent', 'a8a'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/CenterToOptions',
                component: ComponentCreator('/docs/api/workspace/interfaces/CenterToOptions', 'd18'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ChangeOperationsEvent',
                component: ComponentCreator('/docs/api/workspace/interfaces/ChangeOperationsEvent', '274'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ClassicEntityProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/ClassicEntityProps', 'd48'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ClassicToolbarProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/ClassicToolbarProps', 'd76'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ClassicWorkspaceProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/ClassicWorkspaceProps', 'c35'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ClassTreeProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/ClassTreeProps', '628'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/Command',
                component: ComponentCreator('/docs/api/workspace/interfaces/Command', '244'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/CommandBatch',
                component: ComponentCreator('/docs/api/workspace/interfaces/CommandBatch', 'c25'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/CommandHistory',
                component: ComponentCreator('/docs/api/workspace/interfaces/CommandHistory', '487'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/CommandHistoryChangedEvent',
                component: ComponentCreator('/docs/api/workspace/interfaces/CommandHistoryChangedEvent', '522'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/CommandHistoryEvents',
                component: ComponentCreator('/docs/api/workspace/interfaces/CommandHistoryEvents', '026'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/CompositeDataProviderOptions',
                component: ComponentCreator('/docs/api/workspace/interfaces/CompositeDataProviderOptions', 'be4'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ConnectionsMenuCommands',
                component: ComponentCreator('/docs/api/workspace/interfaces/ConnectionsMenuCommands', '950'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ConnectionsMenuProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/ConnectionsMenuProps', '315'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/CreateWorkspaceParams',
                component: ComponentCreator('/docs/api/workspace/interfaces/CreateWorkspaceParams', '24d'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/DataDiagramModelEvents',
                component: ComponentCreator('/docs/api/workspace/interfaces/DataDiagramModelEvents', 'c4a'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/DataGraphStructure',
                component: ComponentCreator('/docs/api/workspace/interfaces/DataGraphStructure', '53c'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/DataLocaleProvider',
                component: ComponentCreator('/docs/api/workspace/interfaces/DataLocaleProvider', 'b3c'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/DataProvider',
                component: ComponentCreator('/docs/api/workspace/interfaces/DataProvider', '423'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/DataProviderDefinition',
                component: ComponentCreator('/docs/api/workspace/interfaces/DataProviderDefinition', 'bc4'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/DataProviderLinkCount',
                component: ComponentCreator('/docs/api/workspace/interfaces/DataProviderLinkCount', '76e'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/DataProviderLookupItem',
                component: ComponentCreator('/docs/api/workspace/interfaces/DataProviderLookupItem', '947'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/DataProviderLookupParams',
                component: ComponentCreator('/docs/api/workspace/interfaces/DataProviderLookupParams', 'bb3'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/DecoratedDataProviderOptions',
                component: ComponentCreator('/docs/api/workspace/interfaces/DecoratedDataProviderOptions', 'f2d'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/DefaultDataLocaleProviderOptions',
                component: ComponentCreator('/docs/api/workspace/interfaces/DefaultDataLocaleProviderOptions', 'b75'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/DefaultLinkProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/DefaultLinkProps', '9f9'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/DefaultLinkRouterOptions',
                component: ComponentCreator('/docs/api/workspace/interfaces/DefaultLinkRouterOptions', '3bf'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/DefaultPropertyEditorProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/DefaultPropertyEditorProps', '880'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/DefaultWorkspaceProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/DefaultWorkspaceProps', '83e'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/DiagramModelEvents',
                component: ComponentCreator('/docs/api/workspace/interfaces/DiagramModelEvents', 'd34'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/DialogSettingsProvider',
                component: ComponentCreator('/docs/api/workspace/interfaces/DialogSettingsProvider', '098'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/DialogStyleProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/DialogStyleProps', '35d'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/DragEditConnect',
                component: ComponentCreator('/docs/api/workspace/interfaces/DragEditConnect', 'b02'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/DragEditMoveEndpoint',
                component: ComponentCreator('/docs/api/workspace/interfaces/DragEditMoveEndpoint', 'f43'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/DraggableHandleProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/DraggableHandleProps', '8fd'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/DropdownMenuItemProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/DropdownMenuItemProps', '7ee'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/DropdownMenuProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/DropdownMenuProps', '9bc'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/DropItemElement',
                component: ComponentCreator('/docs/api/workspace/interfaces/DropItemElement', 'd73'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/DropOnCanvasProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/DropOnCanvasProps', '3ec'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/EditorEvents',
                component: ComponentCreator('/docs/api/workspace/interfaces/EditorEvents', '44d'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ElementEvents',
                component: ComponentCreator('/docs/api/workspace/interfaces/ElementEvents', '90b'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ElementFromJsonOptions',
                component: ComponentCreator('/docs/api/workspace/interfaces/ElementFromJsonOptions', '083'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ElementModel',
                component: ComponentCreator('/docs/api/workspace/interfaces/ElementModel', 'fe3'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ElementProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/ElementProps', 'cf2'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ElementTemplate',
                component: ComponentCreator('/docs/api/workspace/interfaces/ElementTemplate', '8e7'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ElementTypeEvents',
                component: ComponentCreator('/docs/api/workspace/interfaces/ElementTypeEvents', '7e0'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ElementTypeGraph',
                component: ComponentCreator('/docs/api/workspace/interfaces/ElementTypeGraph', 'fe8'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ElementTypeModel',
                component: ComponentCreator('/docs/api/workspace/interfaces/ElementTypeModel', '531'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ElementValidation',
                component: ComponentCreator('/docs/api/workspace/interfaces/ElementValidation', '9d1'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/EntityEditorProvidedProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/EntityEditorProvidedProps', '70a'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/EntityElementEvents',
                component: ComponentCreator('/docs/api/workspace/interfaces/EntityElementEvents', '4df'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/EntityElementProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/EntityElementProps', 'daa'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/EntityGroupEvents',
                component: ComponentCreator('/docs/api/workspace/interfaces/EntityGroupEvents', 'b1f'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/EntityGroupItem',
                component: ComponentCreator('/docs/api/workspace/interfaces/EntityGroupItem', '524'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/EntityGroupProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/EntityGroupProps', '04d'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/Events',
                component: ComponentCreator('/docs/api/workspace/interfaces/Events', '73c'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/EventTrigger',
                component: ComponentCreator('/docs/api/workspace/interfaces/EventTrigger', '387'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ExportRasterOptions',
                component: ComponentCreator('/docs/api/workspace/interfaces/ExportRasterOptions', '87a'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ExportSvgOptions',
                component: ComponentCreator('/docs/api/workspace/interfaces/ExportSvgOptions', '008'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/FetchOperationElement',
                component: ComponentCreator('/docs/api/workspace/interfaces/FetchOperationElement', '565'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/FetchOperationElementType',
                component: ComponentCreator('/docs/api/workspace/interfaces/FetchOperationElementType', 'b34'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/FetchOperationFail',
                component: ComponentCreator('/docs/api/workspace/interfaces/FetchOperationFail', '921'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/FetchOperationLink',
                component: ComponentCreator('/docs/api/workspace/interfaces/FetchOperationLink', 'a10'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/FetchOperationLinkType',
                component: ComponentCreator('/docs/api/workspace/interfaces/FetchOperationLinkType', '72d'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/FetchOperationPropertyType',
                component: ComponentCreator('/docs/api/workspace/interfaces/FetchOperationPropertyType', 'd64'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/FetchOperationTypeToTarget',
                component: ComponentCreator('/docs/api/workspace/interfaces/FetchOperationTypeToTarget', '63a'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/FindCanvasEvent',
                component: ComponentCreator('/docs/api/workspace/interfaces/FindCanvasEvent', '39f'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/FocusGroupController',
                component: ComponentCreator('/docs/api/workspace/interfaces/FocusGroupController', 'e30'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/FullTextSearchSettings',
                component: ComponentCreator('/docs/api/workspace/interfaces/FullTextSearchSettings', '6ce'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/GraphStructure',
                component: ComponentCreator('/docs/api/workspace/interfaces/GraphStructure', 'f72'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/GroupEntitiesParams',
                component: ComponentCreator('/docs/api/workspace/interfaces/GroupEntitiesParams', '751'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/GroupPaginatorProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/GroupPaginatorProps', '7d8'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/HaloLinkProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/HaloLinkProps', '74e'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/HaloProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/HaloProps', '0e1'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/IndexedDbCachedProviderOptions',
                component: ComponentCreator('/docs/api/workspace/interfaces/IndexedDbCachedProviderOptions', 'c3a'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/InstancesSearchCommands',
                component: ComponentCreator('/docs/api/workspace/interfaces/InstancesSearchCommands', '80b'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/InstancesSearchProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/InstancesSearchProps', 'aea'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/LayoutGraph',
                component: ComponentCreator('/docs/api/workspace/interfaces/LayoutGraph', '2a1'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/LayoutLink',
                component: ComponentCreator('/docs/api/workspace/interfaces/LayoutLink', '4d8'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/LayoutNode',
                component: ComponentCreator('/docs/api/workspace/interfaces/LayoutNode', '1b8'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/LayoutState',
                component: ComponentCreator('/docs/api/workspace/interfaces/LayoutState', 'dcd'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/LayoutTypeProvider',
                component: ComponentCreator('/docs/api/workspace/interfaces/LayoutTypeProvider', 'e81'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/LinkActionContext',
                component: ComponentCreator('/docs/api/workspace/interfaces/LinkActionContext', '695'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/LinkActionDeleteProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/LinkActionDeleteProps', 'ce0'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/LinkActionEditProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/LinkActionEditProps', '5b8'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/LinkActionMoveEndpointProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/LinkActionMoveEndpointProps', 'ae4'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/LinkActionProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/LinkActionProps', '769'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/LinkActionRenameProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/LinkActionRenameProps', '188'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/LinkActionSpinnerProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/LinkActionSpinnerProps', 'a70'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/LinkActionStyleProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/LinkActionStyleProps', '26a'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/LinkConfiguration',
                component: ComponentCreator('/docs/api/workspace/interfaces/LinkConfiguration', 'cb4'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/LinkEvents',
                component: ComponentCreator('/docs/api/workspace/interfaces/LinkEvents', 'd82'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/LinkFromJsonOptions',
                component: ComponentCreator('/docs/api/workspace/interfaces/LinkFromJsonOptions', '55c'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/LinkKey',
                component: ComponentCreator('/docs/api/workspace/interfaces/LinkKey', '7c0'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/LinkLabelProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/LinkLabelProps', '473'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/LinkMarkerStyle',
                component: ComponentCreator('/docs/api/workspace/interfaces/LinkMarkerStyle', '0dd'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/LinkModel',
                component: ComponentCreator('/docs/api/workspace/interfaces/LinkModel', '9e4'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/LinkPathProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/LinkPathProps', 'a96'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/LinkProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/LinkProps', '4c7'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/LinkRouter',
                component: ComponentCreator('/docs/api/workspace/interfaces/LinkRouter', '8e9'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/LinkTemplate',
                component: ComponentCreator('/docs/api/workspace/interfaces/LinkTemplate', '4de'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/LinkTemplateProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/LinkTemplateProps', 'b27'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/LinkTypeEvents',
                component: ComponentCreator('/docs/api/workspace/interfaces/LinkTypeEvents', 'e82'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/LinkTypeModel',
                component: ComponentCreator('/docs/api/workspace/interfaces/LinkTypeModel', '542'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/LinkTypesToolboxProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/LinkTypesToolboxProps', '582'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/LinkValidation',
                component: ComponentCreator('/docs/api/workspace/interfaces/LinkValidation', 'f21'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/LinkVerticesProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/LinkVerticesProps', '483'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ListElementViewProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/ListElementViewProps', '129'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/LoadedWorkspace',
                component: ComponentCreator('/docs/api/workspace/interfaces/LoadedWorkspace', 'b7e'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/LoadedWorkspaceParams',
                component: ComponentCreator('/docs/api/workspace/interfaces/LoadedWorkspaceParams', 'dfd'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/MemoryDataset',
                component: ComponentCreator('/docs/api/workspace/interfaces/MemoryDataset', 'fd7'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/MetadataCanConnect',
                component: ComponentCreator('/docs/api/workspace/interfaces/MetadataCanConnect', 'bc1'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/MetadataCanModifyEntity',
                component: ComponentCreator('/docs/api/workspace/interfaces/MetadataCanModifyEntity', '302'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/MetadataCanModifyRelation',
                component: ComponentCreator('/docs/api/workspace/interfaces/MetadataCanModifyRelation', '5f6'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/MetadataCreatedEntity',
                component: ComponentCreator('/docs/api/workspace/interfaces/MetadataCreatedEntity', '354'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/MetadataCreatedRelation',
                component: ComponentCreator('/docs/api/workspace/interfaces/MetadataCreatedRelation', '09f'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/MetadataCreateOptions',
                component: ComponentCreator('/docs/api/workspace/interfaces/MetadataCreateOptions', '0f2'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/MetadataEntityShape',
                component: ComponentCreator('/docs/api/workspace/interfaces/MetadataEntityShape', '0ed'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/MetadataPropertyShape',
                component: ComponentCreator('/docs/api/workspace/interfaces/MetadataPropertyShape', 'e36'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/MetadataProvider',
                component: ComponentCreator('/docs/api/workspace/interfaces/MetadataProvider', '7f4'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/MetadataRelationShape',
                component: ComponentCreator('/docs/api/workspace/interfaces/MetadataRelationShape', '20c'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/NavigatorProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/NavigatorProps', '033'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/OverlayControllerEvents',
                component: ComponentCreator('/docs/api/workspace/interfaces/OverlayControllerEvents', '25b'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/OverlayDialog',
                component: ComponentCreator('/docs/api/workspace/interfaces/OverlayDialog', 'dbf'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/OverlayTask',
                component: ComponentCreator('/docs/api/workspace/interfaces/OverlayTask', '1fa'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/PaperTransform',
                component: ComponentCreator('/docs/api/workspace/interfaces/PaperTransform', '033'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/PinnedProperties',
                component: ComponentCreator('/docs/api/workspace/interfaces/PinnedProperties', 'e52'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ProcessedTypeStyle',
                component: ComponentCreator('/docs/api/workspace/interfaces/ProcessedTypeStyle', '554'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ProgressBarProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/ProgressBarProps', '806'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/PropertyChange',
                component: ComponentCreator('/docs/api/workspace/interfaces/PropertyChange', '885'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/PropertyConfiguration',
                component: ComponentCreator('/docs/api/workspace/interfaces/PropertyConfiguration', '0ee'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/PropertyScore',
                component: ComponentCreator('/docs/api/workspace/interfaces/PropertyScore', '5ca'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/PropertySuggestionParams',
                component: ComponentCreator('/docs/api/workspace/interfaces/PropertySuggestionParams', 'fcd'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/PropertyTypeEvents',
                component: ComponentCreator('/docs/api/workspace/interfaces/PropertyTypeEvents', '800'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/PropertyTypeModel',
                component: ComponentCreator('/docs/api/workspace/interfaces/PropertyTypeModel', 'e7d'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/RdfDataProviderOptions',
                component: ComponentCreator('/docs/api/workspace/interfaces/RdfDataProviderOptions', '70d'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/Rect',
                component: ComponentCreator('/docs/api/workspace/interfaces/Rect', '889'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/RelationEditorProvidedProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/RelationEditorProvidedProps', 'b7c'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/RelationGroupEvents',
                component: ComponentCreator('/docs/api/workspace/interfaces/RelationGroupEvents', '15b'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/RelationGroupItem',
                component: ComponentCreator('/docs/api/workspace/interfaces/RelationGroupItem', '6d5'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/RelationGroupProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/RelationGroupProps', '3d0'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/RelationLinkEvents',
                component: ComponentCreator('/docs/api/workspace/interfaces/RelationLinkEvents', '698'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/RelationLinkProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/RelationLinkProps', '0dd'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/RenameLinkProvider',
                component: ComponentCreator('/docs/api/workspace/interfaces/RenameLinkProvider', 'c48'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/RenderingState',
                component: ComponentCreator('/docs/api/workspace/interfaces/RenderingState', 'd69'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/RenderingStateEvents',
                component: ComponentCreator('/docs/api/workspace/interfaces/RenderingStateEvents', 'baf'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/RequestLinksOptions',
                component: ComponentCreator('/docs/api/workspace/interfaces/RequestLinksOptions', 'fb4'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/RoundEntityProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/RoundEntityProps', '16f'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/RoutedLink',
                component: ComponentCreator('/docs/api/workspace/interfaces/RoutedLink', '531'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ScaleOptions',
                component: ComponentCreator('/docs/api/workspace/interfaces/ScaleOptions', '44f'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SearchInputStore',
                component: ComponentCreator('/docs/api/workspace/interfaces/SearchInputStore', '302'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SearchInputStoreChangeValueEvent',
                component: ComponentCreator('/docs/api/workspace/interfaces/SearchInputStoreChangeValueEvent', 'f3a'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SearchInputStoreEvents',
                component: ComponentCreator('/docs/api/workspace/interfaces/SearchInputStoreEvents', 'a43'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SearchResultsProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/SearchResultsProps', 'dd7'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SelectionActionAddToFilterProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/SelectionActionAddToFilterProps', '5e5'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SelectionActionAnchorProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/SelectionActionAnchorProps', '32f'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SelectionActionAnnotateProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/SelectionActionAnnotateProps', 'a1e'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SelectionActionConnectionsProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/SelectionActionConnectionsProps', '935'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SelectionActionEstablishLinkProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/SelectionActionEstablishLinkProps', '17f'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SelectionActionExpandProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/SelectionActionExpandProps', 'cd8'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SelectionActionGroupProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/SelectionActionGroupProps', '0a2'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SelectionActionLayoutProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/SelectionActionLayoutProps', '8ba'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SelectionActionProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/SelectionActionProps', '832'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SelectionActionRemoveProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/SelectionActionRemoveProps', '556'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SelectionActionSpinnerProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/SelectionActionSpinnerProps', '11f'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SelectionActionStyleProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/SelectionActionStyleProps', 'a7c'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SelectionActionZoomToFitProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/SelectionActionZoomToFitProps', 'e61'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SelectionProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/SelectionProps', '030'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SerializableElementCell',
                component: ComponentCreator('/docs/api/workspace/interfaces/SerializableElementCell', 'b2c'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SerializableLinkCell',
                component: ComponentCreator('/docs/api/workspace/interfaces/SerializableLinkCell', '487'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SerializedAnnotationElement',
                component: ComponentCreator('/docs/api/workspace/interfaces/SerializedAnnotationElement', '57c'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SerializedAnnotationLink',
                component: ComponentCreator('/docs/api/workspace/interfaces/SerializedAnnotationLink', '445'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SerializedDiagram',
                component: ComponentCreator('/docs/api/workspace/interfaces/SerializedDiagram', 'f1c'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SerializedElement',
                component: ComponentCreator('/docs/api/workspace/interfaces/SerializedElement', 'b7a'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SerializedEntityElement',
                component: ComponentCreator('/docs/api/workspace/interfaces/SerializedEntityElement', 'c45'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SerializedEntityGroup',
                component: ComponentCreator('/docs/api/workspace/interfaces/SerializedEntityGroup', 'fb2'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SerializedEntityGroupItem',
                component: ComponentCreator('/docs/api/workspace/interfaces/SerializedEntityGroupItem', '580'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SerializedLayout',
                component: ComponentCreator('/docs/api/workspace/interfaces/SerializedLayout', '646'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SerializedLink',
                component: ComponentCreator('/docs/api/workspace/interfaces/SerializedLink', '2f4'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SerializedLinkOptions',
                component: ComponentCreator('/docs/api/workspace/interfaces/SerializedLinkOptions', 'e11'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SerializedRelationGroup',
                component: ComponentCreator('/docs/api/workspace/interfaces/SerializedRelationGroup', '8ec'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SerializedRelationGroupItem',
                component: ComponentCreator('/docs/api/workspace/interfaces/SerializedRelationGroupItem', '1e3'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SerializedRelationLink',
                component: ComponentCreator('/docs/api/workspace/interfaces/SerializedRelationLink', '2fe'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ShapeGeometry',
                component: ComponentCreator('/docs/api/workspace/interfaces/ShapeGeometry', 'ed5'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SharedCanvasStateEvents',
                component: ComponentCreator('/docs/api/workspace/interfaces/SharedCanvasStateEvents', 'e5f'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/Size',
                component: ComponentCreator('/docs/api/workspace/interfaces/Size', '735'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SizeProvider',
                component: ComponentCreator('/docs/api/workspace/interfaces/SizeProvider', 'd8f'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SparqlDataProviderOptions',
                component: ComponentCreator('/docs/api/workspace/interfaces/SparqlDataProviderOptions', '142'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SparqlDataProviderSettings',
                component: ComponentCreator('/docs/api/workspace/interfaces/SparqlDataProviderSettings', 'fd8'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SparqlProviderChunkOptions',
                component: ComponentCreator('/docs/api/workspace/interfaces/SparqlProviderChunkOptions', '592'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/SpinnerProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/SpinnerProps', '7f8'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/StandardEntityGroupProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/StandardEntityGroupProps', '3d3'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/StandardEntityProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/StandardEntityProps', '92e'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/StandardRelationProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/StandardRelationProps', '27b'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/TemplateProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/TemplateProps', 'ad9'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/TemporaryState',
                component: ComponentCreator('/docs/api/workspace/interfaces/TemporaryState', 'd4a'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ToolbarActionClearAllProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/ToolbarActionClearAllProps', '77b'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ToolbarActionExportProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/ToolbarActionExportProps', 'edd'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ToolbarActionLayoutProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/ToolbarActionLayoutProps', '53e'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ToolbarActionOpenProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/ToolbarActionOpenProps', '610'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ToolbarActionProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/ToolbarActionProps', '2ae'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ToolbarActionRedoProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/ToolbarActionRedoProps', '256'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ToolbarActionSaveProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/ToolbarActionSaveProps', '4a2'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ToolbarActionStyleProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/ToolbarActionStyleProps', '598'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ToolbarActionUndoProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/ToolbarActionUndoProps', 'b31'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ToolbarLanguageSelectorProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/ToolbarLanguageSelectorProps', '071'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ToolbarProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/ToolbarProps', 'df9'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/TrackedWorkspaceContext',
                component: ComponentCreator('/docs/api/workspace/interfaces/TrackedWorkspaceContext', 'c01'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/TranslatedProperty',
                component: ComponentCreator('/docs/api/workspace/interfaces/TranslatedProperty', '829'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/Translation',
                component: ComponentCreator('/docs/api/workspace/interfaces/Translation', '8c4'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/TypeStyle',
                component: ComponentCreator('/docs/api/workspace/interfaces/TypeStyle', '0a4'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/UngroupAllEntitiesParams',
                component: ComponentCreator('/docs/api/workspace/interfaces/UngroupAllEntitiesParams', '921'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/UngroupSomeEntitiesParams',
                component: ComponentCreator('/docs/api/workspace/interfaces/UngroupSomeEntitiesParams', '34f'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/UnifiedSearchCommands',
                component: ComponentCreator('/docs/api/workspace/interfaces/UnifiedSearchCommands', 'c28'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/UnifiedSearchProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/UnifiedSearchProps', '5c9'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/UnifiedSearchSection',
                component: ComponentCreator('/docs/api/workspace/interfaces/UnifiedSearchSection', '08e'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/UnifiedSearchSectionProvidedContext',
                component: ComponentCreator('/docs/api/workspace/interfaces/UnifiedSearchSectionProvidedContext', '250'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/UseAsyncResult',
                component: ComponentCreator('/docs/api/workspace/interfaces/UseAsyncResult', '4b1'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/UseFocusGroupItemResult',
                component: ComponentCreator('/docs/api/workspace/interfaces/UseFocusGroupItemResult', '69a'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/UseProvidedEntitiesResult',
                component: ComponentCreator('/docs/api/workspace/interfaces/UseProvidedEntitiesResult', '258'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/UseSearchInputStoreOptions',
                component: ComponentCreator('/docs/api/workspace/interfaces/UseSearchInputStoreOptions', '6db'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ValidatedElement',
                component: ComponentCreator('/docs/api/workspace/interfaces/ValidatedElement', 'f2f'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ValidatedLink',
                component: ComponentCreator('/docs/api/workspace/interfaces/ValidatedLink', '8eb'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ValidationEvent',
                component: ComponentCreator('/docs/api/workspace/interfaces/ValidationEvent', 'ae2'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ValidationProvider',
                component: ComponentCreator('/docs/api/workspace/interfaces/ValidationProvider', '926'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ValidationResult',
                component: ComponentCreator('/docs/api/workspace/interfaces/ValidationResult', '7f0'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ValidationState',
                component: ComponentCreator('/docs/api/workspace/interfaces/ValidationState', 'c5c'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/Vector',
                component: ComponentCreator('/docs/api/workspace/interfaces/Vector', '399'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ViewportDockProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/ViewportDockProps', '610'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ViewportOptions',
                component: ComponentCreator('/docs/api/workspace/interfaces/ViewportOptions', '259'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/VisualAuthoringCommands',
                component: ComponentCreator('/docs/api/workspace/interfaces/VisualAuthoringCommands', '2c4'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/VisualAuthoringProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/VisualAuthoringProps', 'd83'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/WithFetchStatusProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/WithFetchStatusProps', 'c9a'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/WorkspaceContext',
                component: ComponentCreator('/docs/api/workspace/interfaces/WorkspaceContext', '6ed'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/WorkspaceLanguage',
                component: ComponentCreator('/docs/api/workspace/interfaces/WorkspaceLanguage', '268'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/WorkspaceLayoutContainerProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/WorkspaceLayoutContainerProps', '9f0'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/WorkspaceLayoutItemProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/WorkspaceLayoutItemProps', '2b3'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/WorkspaceLayoutResizeContext',
                component: ComponentCreator('/docs/api/workspace/interfaces/WorkspaceLayoutResizeContext', 'fc9'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/WorkspacePerformLayoutParams',
                component: ComponentCreator('/docs/api/workspace/interfaces/WorkspacePerformLayoutParams', '529'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/WorkspaceProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/WorkspaceProps', '034'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/WorkspaceRootProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/WorkspaceRootProps', '72d'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ZoomControlProps',
                component: ComponentCreator('/docs/api/workspace/interfaces/ZoomControlProps', '287'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/interfaces/ZoomOptions',
                component: ComponentCreator('/docs/api/workspace/interfaces/ZoomOptions', '42e'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/AuthoringState/',
                component: ComponentCreator('/docs/api/workspace/namespaces/AuthoringState/', 'dc4'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/AuthoringState/functions/addEntity',
                component: ComponentCreator('/docs/api/workspace/namespaces/AuthoringState/functions/addEntity', 'a0e'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/AuthoringState/functions/addRelation',
                component: ComponentCreator('/docs/api/workspace/namespaces/AuthoringState/functions/addRelation', '18b'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/AuthoringState/functions/changeEntity',
                component: ComponentCreator('/docs/api/workspace/namespaces/AuthoringState/functions/changeEntity', '5c5'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/AuthoringState/functions/changeRelation',
                component: ComponentCreator('/docs/api/workspace/namespaces/AuthoringState/functions/changeRelation', '211'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/AuthoringState/functions/clone',
                component: ComponentCreator('/docs/api/workspace/namespaces/AuthoringState/functions/clone', '250'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/AuthoringState/functions/deleteEntity',
                component: ComponentCreator('/docs/api/workspace/namespaces/AuthoringState/functions/deleteEntity', '2be'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/AuthoringState/functions/deleteRelation',
                component: ComponentCreator('/docs/api/workspace/namespaces/AuthoringState/functions/deleteRelation', 'f1d'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/AuthoringState/functions/discard',
                component: ComponentCreator('/docs/api/workspace/namespaces/AuthoringState/functions/discard', '910'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/AuthoringState/functions/discardAddedRelations',
                component: ComponentCreator('/docs/api/workspace/namespaces/AuthoringState/functions/discardAddedRelations', 'b8c'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/AuthoringState/functions/has',
                component: ComponentCreator('/docs/api/workspace/namespaces/AuthoringState/functions/has', '23f'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/AuthoringState/functions/hasEntityChangedIri',
                component: ComponentCreator('/docs/api/workspace/namespaces/AuthoringState/functions/hasEntityChangedIri', 'b7c'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/AuthoringState/functions/isAddedEntity',
                component: ComponentCreator('/docs/api/workspace/namespaces/AuthoringState/functions/isAddedEntity', '248'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/AuthoringState/functions/isAddedRelation',
                component: ComponentCreator('/docs/api/workspace/namespaces/AuthoringState/functions/isAddedRelation', '898'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/AuthoringState/functions/isDeletedEntity',
                component: ComponentCreator('/docs/api/workspace/namespaces/AuthoringState/functions/isDeletedEntity', '6ea'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/AuthoringState/functions/isDeletedRelation',
                component: ComponentCreator('/docs/api/workspace/namespaces/AuthoringState/functions/isDeletedRelation', '105'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/AuthoringState/functions/isEmpty',
                component: ComponentCreator('/docs/api/workspace/namespaces/AuthoringState/functions/isEmpty', 'dc7'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/AuthoringState/functions/isEntityEvent',
                component: ComponentCreator('/docs/api/workspace/namespaces/AuthoringState/functions/isEntityEvent', '279'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/AuthoringState/functions/isLinkEvent',
                component: ComponentCreator('/docs/api/workspace/namespaces/AuthoringState/functions/isLinkEvent', '2a4'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/AuthoringState/variables/empty',
                component: ComponentCreator('/docs/api/workspace/namespaces/AuthoringState/variables/empty', '30c'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/Command/',
                component: ComponentCreator('/docs/api/workspace/namespaces/Command/', 'f46'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/Command/functions/compound',
                component: ComponentCreator('/docs/api/workspace/namespaces/Command/functions/compound', '216'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/Command/functions/create',
                component: ComponentCreator('/docs/api/workspace/namespaces/Command/functions/create', '227'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/Command/functions/effect',
                component: ComponentCreator('/docs/api/workspace/namespaces/Command/functions/effect', 'da2'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/Rdf/',
                component: ComponentCreator('/docs/api/workspace/namespaces/Rdf/', '0b4'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/Rdf/functions/compareTerms',
                component: ComponentCreator('/docs/api/workspace/namespaces/Rdf/functions/compareTerms', 'c57'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/Rdf/functions/equalQuads',
                component: ComponentCreator('/docs/api/workspace/namespaces/Rdf/functions/equalQuads', '0f7'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/Rdf/functions/equalTerms',
                component: ComponentCreator('/docs/api/workspace/namespaces/Rdf/functions/equalTerms', '761'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/Rdf/functions/getLocalName',
                component: ComponentCreator('/docs/api/workspace/namespaces/Rdf/functions/getLocalName', '51b'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/Rdf/functions/hashQuad',
                component: ComponentCreator('/docs/api/workspace/namespaces/Rdf/functions/hashQuad', '000'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/Rdf/functions/hashTerm',
                component: ComponentCreator('/docs/api/workspace/namespaces/Rdf/functions/hashTerm', '1fc'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/Rdf/functions/looksLikeTerm',
                component: ComponentCreator('/docs/api/workspace/namespaces/Rdf/functions/looksLikeTerm', '8c8'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/Rdf/functions/termToString',
                component: ComponentCreator('/docs/api/workspace/namespaces/Rdf/functions/termToString', '894'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/Rdf/type-aliases/BaseQuad',
                component: ComponentCreator('/docs/api/workspace/namespaces/Rdf/type-aliases/BaseQuad', '2de'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/Rdf/type-aliases/BlankNode',
                component: ComponentCreator('/docs/api/workspace/namespaces/Rdf/type-aliases/BlankNode', '58c'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/Rdf/type-aliases/DataFactory',
                component: ComponentCreator('/docs/api/workspace/namespaces/Rdf/type-aliases/DataFactory', 'd82'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/Rdf/type-aliases/DefaultGraph',
                component: ComponentCreator('/docs/api/workspace/namespaces/Rdf/type-aliases/DefaultGraph', '24b'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/Rdf/type-aliases/Literal',
                component: ComponentCreator('/docs/api/workspace/namespaces/Rdf/type-aliases/Literal', '584'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/Rdf/type-aliases/NamedNode',
                component: ComponentCreator('/docs/api/workspace/namespaces/Rdf/type-aliases/NamedNode', '162'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/Rdf/type-aliases/Quad',
                component: ComponentCreator('/docs/api/workspace/namespaces/Rdf/type-aliases/Quad', 'edf'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/Rdf/type-aliases/Term',
                component: ComponentCreator('/docs/api/workspace/namespaces/Rdf/type-aliases/Term', '509'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/Rdf/type-aliases/Variable',
                component: ComponentCreator('/docs/api/workspace/namespaces/Rdf/type-aliases/Variable', 'afe'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/Rdf/variables/DefaultDataFactory',
                component: ComponentCreator('/docs/api/workspace/namespaces/Rdf/variables/DefaultDataFactory', '497'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/Rect/',
                component: ComponentCreator('/docs/api/workspace/namespaces/Rect/', '7fc'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/Rect/functions/center',
                component: ComponentCreator('/docs/api/workspace/namespaces/Rect/functions/center', '69f'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/Rect/functions/equals',
                component: ComponentCreator('/docs/api/workspace/namespaces/Rect/functions/equals', '031'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/Rect/functions/intersects',
                component: ComponentCreator('/docs/api/workspace/namespaces/Rect/functions/intersects', '15f'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/TemplateProperties/',
                component: ComponentCreator('/docs/api/workspace/namespaces/TemplateProperties/', 'a68'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/TemplateProperties/variables/AnnotationContent',
                component: ComponentCreator('/docs/api/workspace/namespaces/TemplateProperties/variables/AnnotationContent', 'ae4'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/TemplateProperties/variables/ColorVariant',
                component: ComponentCreator('/docs/api/workspace/namespaces/TemplateProperties/variables/ColorVariant', '546'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/TemplateProperties/variables/CustomLabel',
                component: ComponentCreator('/docs/api/workspace/namespaces/TemplateProperties/variables/CustomLabel', 'e9b'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/TemplateProperties/variables/ElementSize',
                component: ComponentCreator('/docs/api/workspace/namespaces/TemplateProperties/variables/ElementSize', '3f6'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/TemplateProperties/variables/Expanded',
                component: ComponentCreator('/docs/api/workspace/namespaces/TemplateProperties/variables/Expanded', '789'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/TemplateProperties/variables/GroupPageIndex',
                component: ComponentCreator('/docs/api/workspace/namespaces/TemplateProperties/variables/GroupPageIndex', 'bf1'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/TemplateProperties/variables/GroupPageSize',
                component: ComponentCreator('/docs/api/workspace/namespaces/TemplateProperties/variables/GroupPageSize', 'cdd'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/TemplateProperties/variables/LayoutOnly',
                component: ComponentCreator('/docs/api/workspace/namespaces/TemplateProperties/variables/LayoutOnly', 'c82'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/TemplateProperties/variables/PinnedProperties',
                component: ComponentCreator('/docs/api/workspace/namespaces/TemplateProperties/variables/PinnedProperties', 'fdd'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/TemporaryState/',
                component: ComponentCreator('/docs/api/workspace/namespaces/TemporaryState/', '714'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/TemporaryState/functions/addEntity',
                component: ComponentCreator('/docs/api/workspace/namespaces/TemporaryState/functions/addEntity', 'abd'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/TemporaryState/functions/addRelation',
                component: ComponentCreator('/docs/api/workspace/namespaces/TemporaryState/functions/addRelation', 'c8c'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/TemporaryState/functions/removeEntity',
                component: ComponentCreator('/docs/api/workspace/namespaces/TemporaryState/functions/removeEntity', '3ae'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/TemporaryState/functions/removeRelation',
                component: ComponentCreator('/docs/api/workspace/namespaces/TemporaryState/functions/removeRelation', '4d7'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/TemporaryState/variables/empty',
                component: ComponentCreator('/docs/api/workspace/namespaces/TemporaryState/variables/empty', '940'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/ValidationState/',
                component: ComponentCreator('/docs/api/workspace/namespaces/ValidationState/', '862'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/ValidationState/functions/createMutable',
                component: ComponentCreator('/docs/api/workspace/namespaces/ValidationState/functions/createMutable', '501'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/ValidationState/functions/setElementItems',
                component: ComponentCreator('/docs/api/workspace/namespaces/ValidationState/functions/setElementItems', '20d'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/ValidationState/functions/setLinkItems',
                component: ComponentCreator('/docs/api/workspace/namespaces/ValidationState/functions/setLinkItems', 'df3'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/ValidationState/variables/empty',
                component: ComponentCreator('/docs/api/workspace/namespaces/ValidationState/variables/empty', '0d0'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/ValidationState/variables/emptyElement',
                component: ComponentCreator('/docs/api/workspace/namespaces/ValidationState/variables/emptyElement', '66e'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/ValidationState/variables/emptyLink',
                component: ComponentCreator('/docs/api/workspace/namespaces/ValidationState/variables/emptyLink', '2a2'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/Vector/',
                component: ComponentCreator('/docs/api/workspace/namespaces/Vector/', 'c3d'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/Vector/functions/add',
                component: ComponentCreator('/docs/api/workspace/namespaces/Vector/functions/add', '244'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/Vector/functions/cross2D',
                component: ComponentCreator('/docs/api/workspace/namespaces/Vector/functions/cross2D', '84f'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/Vector/functions/dot',
                component: ComponentCreator('/docs/api/workspace/namespaces/Vector/functions/dot', '544'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/Vector/functions/equals',
                component: ComponentCreator('/docs/api/workspace/namespaces/Vector/functions/equals', '2a4'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/Vector/functions/length',
                component: ComponentCreator('/docs/api/workspace/namespaces/Vector/functions/length', '44e'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/Vector/functions/normalize',
                component: ComponentCreator('/docs/api/workspace/namespaces/Vector/functions/normalize', '2da'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/Vector/functions/scale',
                component: ComponentCreator('/docs/api/workspace/namespaces/Vector/functions/scale', '7b7'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/namespaces/Vector/functions/subtract',
                component: ComponentCreator('/docs/api/workspace/namespaces/Vector/functions/subtract', 'f72'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/AnnotationTextStyle',
                component: ComponentCreator('/docs/api/workspace/type-aliases/AnnotationTextStyle', '6fe'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/AnyListener',
                component: ComponentCreator('/docs/api/workspace/type-aliases/AnyListener', 'a58'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/AuthoredEntity',
                component: ComponentCreator('/docs/api/workspace/type-aliases/AuthoredEntity', 'cb3'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/AuthoredRelation',
                component: ComponentCreator('/docs/api/workspace/type-aliases/AuthoredRelation', '214'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/AuthoringEvent',
                component: ComponentCreator('/docs/api/workspace/type-aliases/AuthoringEvent', '197'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/CanvasPlaceAtLayer',
                component: ComponentCreator('/docs/api/workspace/type-aliases/CanvasPlaceAtLayer', 'cfb'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/CanvasPointerMode',
                component: ComponentCreator('/docs/api/workspace/type-aliases/CanvasPointerMode', 'deb'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/Cell',
                component: ComponentCreator('/docs/api/workspace/type-aliases/Cell', 'd11'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/CellHighlighter',
                component: ComponentCreator('/docs/api/workspace/type-aliases/CellHighlighter', '9e6'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/ColorVariant',
                component: ComponentCreator('/docs/api/workspace/type-aliases/ColorVariant', '110'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/CommandAction',
                component: ComponentCreator('/docs/api/workspace/type-aliases/CommandAction', '08e'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/DecoratedMethodName',
                component: ComponentCreator('/docs/api/workspace/type-aliases/DecoratedMethodName', '88d'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/DockDirection',
                component: ComponentCreator('/docs/api/workspace/type-aliases/DockDirection', '990'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/DragEditOperation',
                component: ComponentCreator('/docs/api/workspace/type-aliases/DragEditOperation', '16a'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/DropOnCanvasItem',
                component: ComponentCreator('/docs/api/workspace/type-aliases/DropOnCanvasItem', '251'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/ElementIri',
                component: ComponentCreator('/docs/api/workspace/type-aliases/ElementIri', '07f'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/ElementTemplateComponent',
                component: ComponentCreator('/docs/api/workspace/type-aliases/ElementTemplateComponent', 'f73'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/ElementTemplateResolver',
                component: ComponentCreator('/docs/api/workspace/type-aliases/ElementTemplateResolver', '2d5'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/ElementTypeIri',
                component: ComponentCreator('/docs/api/workspace/type-aliases/ElementTypeIri', 'c0c'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/FetchOperation',
                component: ComponentCreator('/docs/api/workspace/type-aliases/FetchOperation', '81d'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/FetchOperationTargetType',
                component: ComponentCreator('/docs/api/workspace/type-aliases/FetchOperationTargetType', 'b68'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/HotkeyString',
                component: ComponentCreator('/docs/api/workspace/type-aliases/HotkeyString', 'cac'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/KeyedSyncStore',
                component: ComponentCreator('/docs/api/workspace/type-aliases/KeyedSyncStore', '348'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/LabelLanguageSelector',
                component: ComponentCreator('/docs/api/workspace/type-aliases/LabelLanguageSelector', '56e'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/LayoutFunction',
                component: ComponentCreator('/docs/api/workspace/type-aliases/LayoutFunction', 'b99'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/LinkDirection',
                component: ComponentCreator('/docs/api/workspace/type-aliases/LinkDirection', '1b9'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/LinkTemplateResolver',
                component: ComponentCreator('/docs/api/workspace/type-aliases/LinkTemplateResolver', '000'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/LinkTypeIri',
                component: ComponentCreator('/docs/api/workspace/type-aliases/LinkTypeIri', '961'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/LinkTypeVisibility',
                component: ComponentCreator('/docs/api/workspace/type-aliases/LinkTypeVisibility', '5d7'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/Listener',
                component: ComponentCreator('/docs/api/workspace/type-aliases/Listener', '3d8'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/OverlayDialogType',
                component: ComponentCreator('/docs/api/workspace/type-aliases/OverlayDialogType', '0f8'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/ProgressState',
                component: ComponentCreator('/docs/api/workspace/type-aliases/ProgressState', '9ca'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/PropertyEditor',
                component: ComponentCreator('/docs/api/workspace/type-aliases/PropertyEditor', 'f49'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/PropertyEditorOptions',
                component: ComponentCreator('/docs/api/workspace/type-aliases/PropertyEditorOptions', 'a83'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/PropertyEditorResolveInput',
                component: ComponentCreator('/docs/api/workspace/type-aliases/PropertyEditorResolveInput', 'a91'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/PropertySuggestionHandler',
                component: ComponentCreator('/docs/api/workspace/type-aliases/PropertySuggestionHandler', 'b72'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/PropertyTypeIri',
                component: ComponentCreator('/docs/api/workspace/type-aliases/PropertyTypeIri', '313'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/RoutedLinks',
                component: ComponentCreator('/docs/api/workspace/type-aliases/RoutedLinks', 'fa9'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/SparqlQueryFunction',
                component: ComponentCreator('/docs/api/workspace/type-aliases/SparqlQueryFunction', '8b0'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/StandardRelationLabelStyle',
                component: ComponentCreator('/docs/api/workspace/type-aliases/StandardRelationLabelStyle', '64b'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/SubtypeEdge',
                component: ComponentCreator('/docs/api/workspace/type-aliases/SubtypeEdge', 'bdb'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/SyncStore',
                component: ComponentCreator('/docs/api/workspace/type-aliases/SyncStore', '88e'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/TemplateProperty',
                component: ComponentCreator('/docs/api/workspace/type-aliases/TemplateProperty', 'c72'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/TypedElementResolver',
                component: ComponentCreator('/docs/api/workspace/type-aliases/TypedElementResolver', '48f'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/TypedLinkResolver',
                component: ComponentCreator('/docs/api/workspace/type-aliases/TypedLinkResolver', 'e92'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/TypeStyleResolver',
                component: ComponentCreator('/docs/api/workspace/type-aliases/TypeStyleResolver', '62f'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/type-aliases/ValidationSeverity',
                component: ComponentCreator('/docs/api/workspace/type-aliases/ValidationSeverity', '0a4'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/variables/AnnotationTopic',
                component: ComponentCreator('/docs/api/workspace/variables/AnnotationTopic', '2ee'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/variables/BuiltinDialogType',
                component: ComponentCreator('/docs/api/workspace/variables/BuiltinDialogType', '999'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/variables/ClassicTemplate',
                component: ComponentCreator('/docs/api/workspace/variables/ClassicTemplate', 'a43'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/variables/ConnectionsMenuTopic',
                component: ComponentCreator('/docs/api/workspace/variables/ConnectionsMenuTopic', 'c48'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/variables/DBPediaSettings',
                component: ComponentCreator('/docs/api/workspace/variables/DBPediaSettings', '0eb'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/variables/DefaultLinkTemplate',
                component: ComponentCreator('/docs/api/workspace/variables/DefaultLinkTemplate', 'cde'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/variables/DefaultTranslationBundle',
                component: ComponentCreator('/docs/api/workspace/variables/DefaultTranslationBundle', '89e'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/variables/DiagramContextV1',
                component: ComponentCreator('/docs/api/workspace/variables/DiagramContextV1', 'd90'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/variables/InstancesSearchTopic',
                component: ComponentCreator('/docs/api/workspace/variables/InstancesSearchTopic', 'd50'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/variables/LinkMarkerArrowhead',
                component: ComponentCreator('/docs/api/workspace/variables/LinkMarkerArrowhead', '1a7'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/variables/LinkMarkerCircle',
                component: ComponentCreator('/docs/api/workspace/variables/LinkMarkerCircle', 'c41'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/variables/LinkMarkerDiamond',
                component: ComponentCreator('/docs/api/workspace/variables/LinkMarkerDiamond', 'ead'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/variables/NoteLinkTemplate',
                component: ComponentCreator('/docs/api/workspace/variables/NoteLinkTemplate', '4db'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/variables/NoteTemplate',
                component: ComponentCreator('/docs/api/workspace/variables/NoteTemplate', 'b9d'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/variables/owl',
                component: ComponentCreator('/docs/api/workspace/variables/owl', '9b3'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/variables/OwlRdfsSettings',
                component: ComponentCreator('/docs/api/workspace/variables/OwlRdfsSettings', '762'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/variables/OwlStatsSettings',
                component: ComponentCreator('/docs/api/workspace/variables/OwlStatsSettings', '98d'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/variables/PlaceholderDataProperty',
                component: ComponentCreator('/docs/api/workspace/variables/PlaceholderDataProperty', '0f9'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/variables/PlaceholderEntityType',
                component: ComponentCreator('/docs/api/workspace/variables/PlaceholderEntityType', '4c2'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/variables/PlaceholderRelationType',
                component: ComponentCreator('/docs/api/workspace/variables/PlaceholderRelationType', '96e'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/variables/rdf',
                component: ComponentCreator('/docs/api/workspace/variables/rdf', 'b59'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/variables/rdfs',
                component: ComponentCreator('/docs/api/workspace/variables/rdfs', '1de'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/variables/RdfSettings',
                component: ComponentCreator('/docs/api/workspace/variables/RdfSettings', 'a39'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/variables/RoundTemplate',
                component: ComponentCreator('/docs/api/workspace/variables/RoundTemplate', '49e'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/variables/schema',
                component: ComponentCreator('/docs/api/workspace/variables/schema', '82c'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/variables/StandardLinkTemplate',
                component: ComponentCreator('/docs/api/workspace/variables/StandardLinkTemplate', '067'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/variables/StandardTemplate',
                component: ComponentCreator('/docs/api/workspace/variables/StandardTemplate', 'bce'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/variables/subscribeElementTypes',
                component: ComponentCreator('/docs/api/workspace/variables/subscribeElementTypes', '5b9'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/variables/subscribeLinkTypes',
                component: ComponentCreator('/docs/api/workspace/variables/subscribeLinkTypes', '919'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/variables/subscribePropertyTypes',
                component: ComponentCreator('/docs/api/workspace/variables/subscribePropertyTypes', '242'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/variables/UnifiedSearchTopic',
                component: ComponentCreator('/docs/api/workspace/variables/UnifiedSearchTopic', 'd09'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/variables/VisualAuthoringTopic',
                component: ComponentCreator('/docs/api/workspace/variables/VisualAuthoringTopic', '61a'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/variables/WikidataSettings',
                component: ComponentCreator('/docs/api/workspace/variables/WikidataSettings', '316'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/variables/WorkspaceLayoutResizeContext',
                component: ComponentCreator('/docs/api/workspace/variables/WorkspaceLayoutResizeContext', 'fcb'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/api/workspace/variables/xsd',
                component: ComponentCreator('/docs/api/workspace/variables/xsd', 'c09'),
                exact: true,
                sidebar: "api"
              },
              {
                path: '/docs/category/components',
                component: ComponentCreator('/docs/category/components', 'd2a'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/category/concepts',
                component: ComponentCreator('/docs/category/concepts', 'cd6'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/category/examples',
                component: ComponentCreator('/docs/category/examples', 'e34'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/components/annotation-support',
                component: ComponentCreator('/docs/components/annotation-support', '295'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/components/canvas',
                component: ComponentCreator('/docs/components/canvas', '258'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/components/class-tree',
                component: ComponentCreator('/docs/components/class-tree', 'b80'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/components/connections-menu',
                component: ComponentCreator('/docs/components/connections-menu', '8bb'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/components/drop-on-canvas',
                component: ComponentCreator('/docs/components/drop-on-canvas', '2a4'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/components/form-input',
                component: ComponentCreator('/docs/components/form-input', 'b37'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/components/instances-search',
                component: ComponentCreator('/docs/components/instances-search', 'cbd'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/components/link-types-toolbox',
                component: ComponentCreator('/docs/components/link-types-toolbox', '19c'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/components/navigator',
                component: ComponentCreator('/docs/components/navigator', '86e'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/components/selection',
                component: ComponentCreator('/docs/components/selection', '096'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/components/toolbar',
                component: ComponentCreator('/docs/components/toolbar', 'da2'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/components/unified-search',
                component: ComponentCreator('/docs/components/unified-search', 'd09'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/components/visual-authoring',
                component: ComponentCreator('/docs/components/visual-authoring', '133'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/components/workspace',
                component: ComponentCreator('/docs/components/workspace', '18a'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/components/workspace-layout-panels',
                component: ComponentCreator('/docs/components/workspace-layout-panels', '7f3'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/components/zoom-control',
                component: ComponentCreator('/docs/components/zoom-control', '9d9'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/concepts/canvas-coordinates',
                component: ComponentCreator('/docs/concepts/canvas-coordinates', '954'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/concepts/canvas-overlays',
                component: ComponentCreator('/docs/concepts/canvas-overlays', '272'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/concepts/command-history',
                component: ComponentCreator('/docs/concepts/command-history', 'c0a'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/concepts/data-provider',
                component: ComponentCreator('/docs/concepts/data-provider', 'd39'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/concepts/design-system',
                component: ComponentCreator('/docs/concepts/design-system', 'e05'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/concepts/event-system',
                component: ComponentCreator('/docs/concepts/event-system', '76d'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/concepts/graph-authoring',
                component: ComponentCreator('/docs/concepts/graph-authoring', 'd17'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/concepts/graph-layout',
                component: ComponentCreator('/docs/concepts/graph-layout', 'a0f'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/concepts/graph-model',
                component: ComponentCreator('/docs/concepts/graph-model', 'b00'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/concepts/i18n',
                component: ComponentCreator('/docs/concepts/i18n', '908'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/concepts/keyboard-hotkeys',
                component: ComponentCreator('/docs/concepts/keyboard-hotkeys', '489'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/concepts/workspace-context',
                component: ComponentCreator('/docs/concepts/workspace-context', '1f1'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/examples/basic',
                component: ComponentCreator('/docs/examples/basic', 'e89'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/examples/classic-workspace',
                component: ComponentCreator('/docs/examples/classic-workspace', '3d2'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/examples/graph-authoring',
                component: ComponentCreator('/docs/examples/graph-authoring', 'ed3'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/examples/live',
                component: ComponentCreator('/docs/examples/live', 'a7b'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/examples/rdf-explorer',
                component: ComponentCreator('/docs/examples/rdf-explorer', 'f8e'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/examples/sparql',
                component: ComponentCreator('/docs/examples/sparql', 'f44'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/examples/stress-test',
                component: ComponentCreator('/docs/examples/stress-test', '836'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/examples/style-customization',
                component: ComponentCreator('/docs/examples/style-customization', '625'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/examples/wikidata',
                component: ComponentCreator('/docs/examples/wikidata', 'bf6'),
                exact: true,
                sidebar: "docs"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/',
    component: ComponentCreator('/', 'e5f'),
    exact: true
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
